import { HStack, Tooltip } from "@chakra-ui/react";
import moment from "moment-timezone";
import CDS from "design-system";
import { formatRelativeDueDate, taskDisplayTimezone } from "../helpers";
import { Task, TaskSummary } from "../models";

export function StartsTag({ task }: { task: Task | TaskSummary }) {
  if (task.status !== "upcoming" || !task.effectiveStartDate) return null;
  // Render in the assignee's timezone so an instant that crossed UTC midnight
  // doesn't display the next day's date.
  const startLabel = moment.tz(String(task.effectiveStartDate), taskDisplayTimezone(task)).format("MMM D");
  return (
    <CDS.Text10 color="gray.400" fontStyle="italic" whiteSpace="nowrap">
      Starts {startLabel}
    </CDS.Text10>
  );
}

export function DueTag({ task }: { task: Task | TaskSummary }) {
  const shouldHide = ["completed", "skipped", "upcoming"].includes(task.status);
  if (!task.dueOn || shouldHide) return null;

  const color = task.isOverdue ? "red.500" : task.isUrgent ? "orange.500" : "gray.400";
  const label = task.isOverdue ? "This task is overdue" : task.isUrgent ? "Due soon" : undefined;

  const text = (
    <CDS.Text10 fontWeight="600" color={color} whiteSpace="nowrap">
      {task.isOverdue ? `Due ${moment(task.dueOn).format("MMM D")}` : (formatRelativeDueDate(task.dueAt) ?? `Due ${moment(task.dueOn).format("MMM D")}`)}
    </CDS.Text10>
  );

  return label ? <Tooltip label={label} placement="top">{text}</Tooltip> : text;
}

export default function StartOrDueDateTag({ task }: { task: Task | TaskSummary }) {
  return (
    <HStack spacing={2} align="center">
      <StartsTag task={task} />
      <DueTag task={task} />
    </HStack>
  );
}
